import SuccessDotIcon from '@assets/icons/dots/accepted.svg';
import RejectDotIcon from '@assets/icons/dots/rejected.svg';
import { useLingui } from '@lingui/react/macro';
import {
    PillMainWrapper,
    PillStatusWrapper,
    PillTitleStatusWrapper,
} from '@routes/sidebar/admin-center/tenant-client/___pages___/configuration/___shared___/components/built-in-status-pill/styled.ts';
import { toActiveBool } from '@routes/sidebar/admin-center/tenant-client/ui/tenant-client-groupBy-table/helpers.tsx';

export const BuiltInStatusPill = ({ builtIn }: { builtIn: boolean }) => {
    const { t } = useLingui();

    const isBuiltIn = toActiveBool(builtIn);
    const label = isBuiltIn ? t`Yes` : t`No`;

    return (
        <PillMainWrapper>
            <PillStatusWrapper $isBuiltIn={builtIn}>
                {builtIn ? <SuccessDotIcon /> : <RejectDotIcon />}
                <PillTitleStatusWrapper $isBuiltIn={builtIn}>{label}</PillTitleStatusWrapper>
            </PillStatusWrapper>
        </PillMainWrapper>
    );
};
